module.exports = __webpack_public_path__ + "media/img/patterns/reticle-frame-light-a27525504b62ceb008446177db6023a7.svg";